/**
 * PremiumAgent
 * 
 * @Author: Focci
 * @Date: 2024-10-25 13:44:34
 * @Last Modified by: Focci
 * @Last Modified time: 2024-10-25 13:44:34
 */

import { getListingData, soldDefaultPrice } from '@comp/page/search/get-listing-data'
import { clone, isArray, map, pick } from 'lodash-es'
import { formatPrice, isValid } from '@lib/utils'
import PropertyCardScoff from '../../property/PropertyCardScoff'
import PremiumAgentPanel from './PremiumAgentPanel'
import PremiumAgentCarouselListings from './PremiumAgentCarouselListings'
import PremiumMultiple from './PremiumMultiple'
import PremiumSold from './PremiumSold'
import { getPremiumListings } from './_'

function getAgentData(agent) {
  return agent ? {
    agentAvatar: agent.icon,
    agentName: agent.name,
    officeName: agent.office_name,
    officeIcon: agent.office_oss_avatar,
    officeColor: agent.bg_color,
    officeFontColor: agent.font_color,
  } : {}
}

function getPremiumSoldData(house, solds) {
  const sold = solds[0]
  let extra = {}
  
  if(!sold?.simple_agents?.[0] && house?.agent) {
    sold.simple_agents = [{
      ...pick(house.agent, ['id', 'email', 'language', 'membership_level', 'name', 'slug']),
      avatar: house.agent.icon,
      phone: house.agent.phone_number,
    }]

    extra = getAgentData(house.agent)
  }

  return {
    ...getPremiumListings(null, [sold])?.[0],
    ...extra
  }
}

function getSoldData(target, type) {
  return {
    ...getListingData(target, type),
    ...getAgentData(target?.simple_agents?.[0]),
    simple_agents: map(
      isArray(target?.simple_agents) ? target.simple_agents : [],
      (agent) => ({
        ...pick(agent, ['name', 'id', 'slug', 'membership_level']),
        avatar: agent.icon,
      })
    )
  }
}

export default function PremiumAgent({ house, variant, type, isSoldPremium }) {
  const target = clone(house)
  const { properties, sold_properties: solds } = target || {}

  if(isValid(target?.agent?.avg_sold_value) || isValid(target?.agent?.sold_count)) {
    target.agent.list_stat = {
      sold_avm_label: `$${formatPrice(target.agent.avg_sold_value)}`,
      sold_count: target.agent.sold_count,
    }
  }

  // 买房列表只有 sold_properties里面有数据
  // 或者售出列表是 premium 房源
  const onlySold = properties?.length === 0 && solds?.length === 1
  if(isSoldPremium || onlySold) {
    const houseData = isSoldPremium 
      ? getSoldData(target, type)
      : getPremiumSoldData(target, solds)

    // 售出价格 如果没有给则不显示
    // 企业微信[后花园生产队] matthew zheng 2024-11-04 09:35
    houseData.priceLabel = houseData.priceLabel === soldDefaultPrice 
      ? '' 
      : houseData.priceLabel

    return (
      <PremiumSold
        variant={variant}
        house={houseData} 
      />
    )
  }
  
  if(variant === 'multiple') {
    return <PremiumMultiple house={target} />
  }
  
  return (
    <PropertyCardScoff>
      <PremiumAgentPanel house={target} />
      <PremiumAgentCarouselListings house={target} />
    </PropertyCardScoff>
  )
}
